import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyB8bZHZLGGJIPto-5K7Fei-JoSZ-90M2wE",
    authDomain: "christmas-tree-db307.firebaseapp.com",
    databaseURL: "https://christmas-tree-db307-default-rtdb.firebaseio.com",
    projectId: "christmas-tree-db307",
    storageBucket: "christmas-tree-db307.firebasestorage.app",
    messagingSenderId: "631525668702",
    appId: "1:631525668702:web:5107d8ab1f84e61897c1cf",
    measurementId: "G-KS118TJX6M"
  };
  
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
export default app;